module.exports = { "default": require("core-js/library/fn/string/raw"), __esModule: true };